
import styles from './media_and_content.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Media from './basic/media'
import Button from './basic/button'
import Title from './basic/title'
import Wysiwyg from './wysiwyg'


function MediaAndContent(props) {
	const fields = props.fields

	return <BlockWrapper {...props} className={styles.listing_content}>
		<ScrollAnimation styles={styles}>
			<div className={styles.media_and_content}>
				<div className={styles.content}>
					<Title fields={{
						title: fields.title,
						divider: true,
						heading_type: 'h2',
					}} />
					<Wysiwyg fields={{content: fields.content}} />
					<br />
					{fields.button && <Button fields={{button: {url: fields.button.url, title: fields.button.title}}} appearance='solid' color='green' className={styles.button}>{fields.button.title}</Button>}
				</div>
				<div className={styles.media}>
					<Media media_type={fields.media.type} image={fields.media} />
				</div>
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default MediaAndContent